import { TAction } from "../../base/types/redux";
import ReducerRegistry from "../../base/redux/ReducerRegistry";
import { UserInfo } from "../utils/types";
import { ACTION_TYPES } from "./actionTypes";

const initState: any = {
  userInfo: {},
  getLoginState: {
    isFetching: false,
    isSuccess: null,
    data: null
  },
  getForgotPasswordState: {
    isFetching: false,
    isSuccess: null,
    data: null
  },
  userLogin: {
    username: null,
    password: null,
  }
};

const reducer = (state = initState, action: TAction) => {
  switch (action.type) {
    case ACTION_TYPES.SET_LOGIN_STATE: {
      return {
        ...state,
        getLoginState: action.response,
      };
    }
    case ACTION_TYPES.SET_USER_INFO: {
      return {
        ...state,
        userInfo: action.response,
      };
    }
    case ACTION_TYPES.SET_FORGOT_PASSWORD_STATE: {
      return {
        ...state,
        getForgotPasswordState: action.response,
      };
    }
    case ACTION_TYPES.SET_USER_LOGIN_REMEMBER: {
      return {
        ...state,
        userLogin: action.response,
      };
    }
    default:
      return state;
  }
};

ReducerRegistry.register("login", reducer);
